var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLiked = function SvgLiked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    viewBox: "0 0 18.4 18.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E86D",
    d: "m1.008 10.42-.29 5.2a2 2 0 0 0 1.998 2.11h10.5a2 2 0 0 0 .743-.143l1.122-.448a2 2 0 0 0 1.223-1.489l1.158-6.173a2 2 0 0 0-.251-1.398l-.45-.748a2 2 0 0 0-1.935-.959l-1.004.112a2 2 0 0 1-2.22-1.988v-1.53A2 2 0 0 0 9.884.985l-.13-.02a2 2 0 0 0-2.18 1.348L6.006 7.016A2 2 0 0 1 4.33 8.372l-1.546.172a2 2 0 0 0-1.776 1.876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C88B1",
    d: "M14.5 18.48H.75a.75.75 0 0 1-.75-.75v-8a2.25 2.25 0 0 1 2.25-2.25h3.07l2.73-7a.75.75 0 0 1 .7-.48h1a2.75 2.75 0 0 1 2.75 2.73v3.25h3a2.74 2.74 0 0 1 2.73 3.12l-1 7a2.75 2.75 0 0 1-2.73 2.38m-13-1.5h13a1.26 1.26 0 0 0 1.24-1.08l.95-7a1.24 1.24 0 0 0-1.24-1.42h-3.7a.75.75 0 0 1-.75-.75v-4a1.26 1.26 0 0 0-1.25-1.25h-.49l-2.73 7a.75.75 0 0 1-.7.48H2.25a.75.75 0 0 0-.75.75z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLiked);
export default ForwardRef;